import Layout from '../../internal/Layout.vue'
import CalibrationPage from './Calibration/calibration.vue'
import ManageCalibrationPattern from './components/ManageCalibrationPattern/ManageCalibrationPattern.vue'
import CalibrationPatternUseApprovedTable from './components/CalibrationPatternUseApprovedTable/CalibrationPatternUseApprovedTable.vue'
import ManageTemplate from './components/ManageCalibrationPatternTemplate/ManageCalibrationPatternTemplate.vue'
import ManageCalibration from './components/ManageCalibration/ManageCalibration.vue'
import CalibrationCertified from './components/CalibrationCertified/CalibrationCertified.vue'

const CalibrationRoutes = {
  component: Layout,
  children: [
    {
      name: 'calibration',
      path: '/',
      component: CalibrationPage,
      meta: {
        module: 'calibracao',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
    {
      name: 'newCalibrationPattern',
      path: '/newCalibrationPattern',
      component: ManageCalibrationPattern,
      meta: {
        module: 'calibracao',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
    {
      name: 'editCalibrationPattern',
      path: '/editCalibrationPattern/:calibrationPatternIdProps',
      component: ManageCalibrationPattern,
      props: true,
      meta: {
        module: 'calibracao',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
    {
      name: 'newCalibrationPatternTemplate',
      path: '/newCalibrationPatternTemplate',
      component: ManageTemplate,
      meta: {
        module: 'calibracao',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
    {
      name: 'editCalibrationPatternTemplate',
      path: '/editCalibrationPatternTemplate/:patternTemplateId',
      component: ManageTemplate,
      props: true,
      meta: {
        module: 'calibracao',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
    {
      name: 'resquestApproved',
      path: '/resquestApproved',
      component: CalibrationPatternUseApprovedTable,
      meta: {
        module: 'calibracao',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
    {
      name: 'formCalibration',
      path: '/formCalibration',
      component: ManageCalibration,
      meta: {
        module: 'calibracao',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
    {
      name: 'calibrationCertified',
      path: '/calibrationCertified/:serviceOrderId',
      component: CalibrationCertified,
      props: true,
      meta: {
        module: 'calibracao',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
  ],
}

export default CalibrationRoutes
